import React from 'react';
import { useState } from 'react';
import { useEffect } from 'react';
import { Table } from 'antd';
import API from "../../Services/BaseService";
import Loading from "../../Component/Loading/Loading";
import AppStoreImg from '../../../src/assets/img/appstore.png';
import GooglePlayImg from '../../../src/assets/img/googleplay.png';
import { useDispatch, useSelector } from "react-redux";
import PageNotFound from '../FallBackUI/PageNotFound';
import { useHistory } from "react-router-dom";
import '../Fees/Fees.css'

const Fees = () => {
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(true);
    const [feeDetails, setFeeDetails] = useState("");
    const successData = useSelector(state => state.LoginReducer.payload);
    const [errors, setErrors] = useState("");
    const [errorFlag, setErrorFlag] = useState(false);
    const dealerData = useSelector(state => state.DealerReducer.payload);
    const history = useHistory();


    const columns = [
        {
            title: 'Selling Price',
            dataIndex: 'fee_price',
            key: 'fee_price',
        },
        {
            title: 'sell Fee',
            dataIndex: 'fee',
            key: 'fee',
        }
    ];

    async function logedBuyerFees() {
        console.log("inside fn");
        let request = {
            type: "Seller",
            seller_id: successData.seller_id,
            seller_token: successData.seller_token,
        };
        const state = API.post('fees/condition', request);
        state.then(res => {
            console.log("res", res)
            if (res.data.success === true) {
                setFeeDetails(res.data.data);
                setLoading(false);
            }
            else {
                setErrors(res.data.error)
                setErrorFlag(true)
            }
        })
            .catch(function (error) {
                if (error.response) {
                    setErrors(error.response.data.error)
                    setErrorFlag(true)
                }
            });
    }



    async function fetchBuyerFees(data) {
        console.log("inside fn");
        let request = {
            type: "Seller",
            seller_dealer_id: data == undefined || data === null ? successData.seller_dealer_id : data.seller_dealer_id,
            // seller_dealer_id: data == undefined ?dealerData !== null ? dealerData.seller_dealer_id: successData.seller_dealer_id :data ,
            seller_id: successData.seller_id,
            seller_token: successData.seller_token
        };
        const state = API.post('sellerFees/condition', request);
        state.then(res => {
            console.log("res", res)
            if (res.data.success === true) {
                setFeeDetails(res.data.data);
                setLoading(false);
            }
            else {
                setErrors(res.data.error)
                setErrorFlag(true)
            }
        })
            .catch(function (error) {
                if (error.response) {
                    setErrors(error.response.data.error)
                    setErrorFlag(true)
                }
            });
    }
    useEffect(() => {
        {
            localStorage.getItem("islogedIn") === "true" ?

                fetchBuyerFees(dealerData) :
                logedBuyerFees();
        }

    }, [dealerData]);


    return (
        <div>
            <main id="main" className="">
               
                    {errorFlag === true ? <PageNotFound error={errors} /> :
                        <div className="container-fluid inner-page-space">


                            <div id="fees">
                                <div className="row fees-block">
                                    <div className="col-lg-12">
                                        <div class="back-btn">
                                            <a class="back-btn-primary" onClick={() => history.push("/carlist")}><i class="bx bx-chevron-left"></i> Back</a>
                                        </div>
                                    </div>
                                    <div className="col-lg-8">
                                        <div className="inner-title">FEES</div>
                                        <p className="sub-titles">Thank you for interesting in our platform, We wish you make money and come back to buy more cars</p>

                                        <div className="feestable">
                                            {loading ? <Loading /> :
                                                <div className="table-responsive">
                                                    <table className="table no-wrap">
                                                        <thead>
                                                            <tr>
                                                                <th className="border-top-0">Buying Price</th>
                                                                <th className="border-top-0">Buy Fee</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {feeDetails.length > 0 ? feeDetails.sort((a, b) => b.user_id - a.user_id)
                                                                .map((feeDetails) =>
                                                                    <tr>
                                                                        <td>${feeDetails?.from_price}-${feeDetails?.to_price}</td>
                                                                        <td>${feeDetails?.fee}</td>
                                                                    </tr>
                                                                ) : <tr><td colspan="8" className='text-center'><p>No Data Found</p> </td></tr>}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }

               
                    <div className="container-fluid inner-page-space">
                        <div className="row playstore-btn">
                            <div className="col-lg-12">
                                <img src={AppStoreImg} />
                                <img src={GooglePlayImg} />
                            </div>
                        </div>
                    </div>
              

            </main >
        </div >

    );
};

export default Fees;